module.exports = __webpack_public_path__ + "img/3.2d86e252.jpg";